import type { FetchResponse } from '@cian/http-api';
import { type IHttpApi } from '@cian/http-api/shared';
import { type ILogger } from '@cian/logger/shared';

import { ResponseError } from '../../errors';
import {
  fetchCianApiSiteV1GetQuickLinks,
  TCianApiSiteV1GetQuickLinksResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-quick-links';
import { IJsonQuery } from '../../json_query';
import { IOldQuickLinks } from '../../types/quickLinks';

interface IFetchOldQuickLinksParameters {
  subdomain: string;
  jsonQuery: IJsonQuery;
}

interface IContext {
  httpApi: IHttpApi;
  logger: ILogger;
}

async function fetchOldQuickLinks(
  { httpApi }: IContext,
  { subdomain, jsonQuery }: IFetchOldQuickLinksParameters,
): Promise<IOldQuickLinks | null> {
  const response: FetchResponse<TCianApiSiteV1GetQuickLinksResponse> = await fetchCianApiSiteV1GetQuickLinks({
    httpApi,
    parameters: { jsonQuery },
    config: { subdomain },
  });

  if (response.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchOldQuickLinks',
      message: response.response.data?.message || '',
      details: {
        error: JSON.stringify(response.response.data?.errors),
      },
    });
  }

  const quickLinks = response.response.data.quickLinks;

  if (!quickLinks || !quickLinks.links || quickLinks.links.length === 0) {
    return null;
  }

  return {
    level: quickLinks.level ?? 0,
    links: quickLinks.links,
  };
}

export async function fetchOldQuickLinksSafe(
  context: IContext,
  parameters: IFetchOldQuickLinksParameters,
): Promise<IOldQuickLinks | null> {
  try {
    return await fetchOldQuickLinks(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Быстрые ссылки (легаси)' });

    return null;
  }
}
